module.exports = __webpack_public_path__ + "static/displacer_beast-2dc343717419e98601fa22d13ac909f8.jpg";